<template>
  <section class="clients-section">
    <v-container class="clients-container">
      <!-- Section Header -->
      <div class="section-header animate-block">
        <p class="section-title">{{ $t('clients.title') }}</p>
        <p class="section-subtitle">{{ $t('clients.subtitle') }}</p>
      </div>

      <!-- Clients Grid -->
      <v-row no-gutters class="clients-grid">
        <v-col
          v-for="(client, index) in clients"
          :key="index"
          cols="6"
          md="3"
          class="animate-block grid-cell"
        >
          <div class="client-card">
            <div class="logo-place">
              <img
                v-if="client.logo"
                :src="client.logo"
                :alt="client.name"
                class="logo-image"
              />
              <span v-else class="logo-placeholder">{{ client.shortName }}</span>
            </div>
            <p class="client-name">{{ client.name }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'ClientsSection',
  mixins: [animateOnScroll],
  data() {
    return {
      clients: [
        {
          name: 'GLORIA-QVARC S.R.L.',
          shortName: 'GLORIA-QVARC',
          logo: require('@/assets/images/7.ClientsSection/0.webp')
        },
        {
          name: 'ACADEMIA DE STUDII ECONOMICE',
          shortName: 'ASEM',
          logo: require('@/assets/images/7.ClientsSection/1.webp')
        },
        {
          name: 'AGRO-NOVA PRIM S.R.L.',
          shortName: 'AGRONOVA',
          logo: require('@/assets/images/7.ClientsSection/2.webp')
        },
        {
          name: 'AMBASADA SUA',
          shortName: 'Embassy',
          logo: require('@/assets/images/7.ClientsSection/3.webp')
        },
        {
          name: 'INSTITUȚIA PUBLICĂ ADMINISTRAȚIA NAȚIONALĂ „APELE-MOLDOVEI"',
          shortName: 'APELE MOLDOVEI',
          logo: require('@/assets/images/7.ClientsSection/4.webp')
        },
        {
          name: 'ARAMA R S.R.L.',
          shortName: 'Domus Italia',
          logo: require('@/assets/images/7.ClientsSection/5.webp')
        },
        {
          name: 'DALMORS-GRUP S.R.L.',
          shortName: 'DALMORS',
          logo: require('@/assets/images/7.ClientsSection/6.webp')
        },
        {
          name: 'DINA-COCIUG S.R.L.',
          shortName: 'DINA',
          logo: require('@/assets/images/7.ClientsSection/7.webp')
        },
        {
          name: 'EUROINSTAL S.R.L.',
          shortName: 'Euro Instal',
          logo: require('@/assets/images/7.ClientsSection/8.webp')
        },
        {
          name: 'INAMSTRO S.R.L.',
          shortName: 'INAMSTRO',
          logo: require('@/assets/images/7.ClientsSection/9.webp')
        },
        {
          name: 'SYNEVO MOLDOVA',
          shortName: 'synevo',
          logo: require('@/assets/images/7.ClientsSection/10.webp')
        },
        {
          name: 'Î.M. ORANGE MOLDOVA S.A.',
          shortName: 'orange',
          logo: require('@/assets/images/7.ClientsSection/11.webp')
        },
        {
          name: 'ANTURAJ-NOU S.R.L.',
          shortName: 'ANTURAJ',
          logo: null
        },
        {
          name: 'TEHNO-TRANS S.R.L.',
          shortName: 'TEHNO-TRANS',
          logo: null
        },
        {
          name: 'GLORIA-QVARC S.R.L.',
          shortName: 'GLORIA-QVARC',
          logo: null
        },
        {
          name: 'S.C. NISVINEX GRUP S.R.L.',
          shortName: 'NISVINEX',
          logo: null
        },
        {
          name: 'FABRICA OLOI-PAK S.R.L.',
          shortName: 'OLOI-PAK',
          logo: null
        }
      ]
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400&display=swap');

.clients-section {
  background-color: #ededed;
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.clients-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}

/* Header */
.section-header {
  max-width: 511px;
}

.section-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(28, 165, 190);
  margin: 0;
}

.section-subtitle {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(46, 46, 46);
  margin: 0;
}

/* Grid */
.clients-grid {
  width: 100%;
  gap: 10px;
}

.grid-cell {
  padding: 0 !important;
  max-width: calc(25% - 7.5px);
  flex-basis: calc(25% - 7.5px);
}

/* Client Card */
.client-card {
  background-color: #dedede;
  border-radius: 4px;
  height: 198px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
  overflow: hidden;
  transition: background-color 0.2s ease;
}

.client-card:hover {
  background-color: #e8e8e8;
}

/* Logo area */
.logo-place {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  display: block;
  max-width: 100%;
  max-height: 78px;
  object-fit: contain;
}

.logo-placeholder {
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  font-weight: 400;
  color: rgb(103, 103, 103);
  text-transform: uppercase;
  letter-spacing: -0.04em;
  text-align: center;
}

/* Client name */
.client-name {
  font-family: "JetBrains Mono", monospace;
  font-size: 8px;
  font-weight: 400;
  letter-spacing: -0.04em;
  color: rgb(103, 103, 103);
  text-transform: uppercase;
  margin: 0;
  margin-top: auto;
  padding-bottom: 6px;
  align-self: flex-start;
  padding-left: 2px;
}

/* Empty cards */
.empty-card {
  background-color: #ededed;
}

/* Description card */
.description-card {
  background-color: #ad2525;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 39px 15px 6px;
}

.description-text {
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 16px;
  color: rgb(46, 46, 46);
  margin: 0;
  word-break: break-word;
}

.partner-name {
  font-family: "JetBrains Mono", monospace;
  font-size: 8px;
  font-weight: 400;
  letter-spacing: -0.04em;
  color: rgb(46, 46, 46);
  text-transform: uppercase;
  margin: 0;
  margin-top: auto;
}

/* Responsive */
@media (max-width: 960px) {
  .clients-section {
    padding: 60px 0;
  }

  .grid-cell {
    max-width: calc(50% - 5px);
    flex-basis: calc(50% - 5px);
  }

  .section-header {
    width: 100%;
  }

  .section-title,
  .section-subtitle {
    font-size: 26px;
    line-height: 34px;
  }
}

@media (max-width: 600px) {
  .clients-section {
    padding: 40px 0;
  }

  .section-title,
  .section-subtitle {
    font-size: 22px;
    line-height: 30px;
  }
}
</style>
